module.exports = __webpack_public_path__ + "img/57.38b95a8c.jpg";